import jsPDF from "jspdf";

export const generatePDFInvoice = (salaryData) => {
  const doc = new jsPDF();

  // Company Logo
  const logoWidth = 40;
  const logoHeight = 20;
  doc.addImage("/rectangle-9@2x.png", "PNG", 10, 10, logoWidth, logoHeight);

  // Title
  doc.setFontSize(24);
  doc.setTextColor(40); // Dark gray
  doc.text("Salary Slip", doc.internal.pageSize.getWidth() / 2, 40, {
    align: "center",
  });

  // Employee Details Section
  doc.setFontSize(14);
  doc.setTextColor(0); // Black
  doc.setFillColor(245, 245, 245); // Light gray background
  doc.roundedRect(15, 60, doc.internal.pageSize.getWidth() - 30, 80, 5, 5, "F"); // Rounded rectangle for section

  let yPosition = 70;
  doc.text(`Name: ${salaryData.name || "N/A"}`, 25, yPosition);
  doc.text(`Employee ID: ${salaryData.user_id}`, doc.internal.pageSize.getWidth() / 2, yPosition);
  yPosition += 15;
  doc.text(`Phone: ${salaryData.phone || "N/A"}`, 25, yPosition);
  doc.text(`Address: ${salaryData.address || "N/A"}`, doc.internal.pageSize.getWidth() / 2, yPosition);

  // Salary Details Section
  doc.setFillColor(230, 230, 230); // Slightly darker gray for salary section
  doc.roundedRect(15, 150, doc.internal.pageSize.getWidth() - 30, 100, 5, 5, "F");

  yPosition = 160;
  doc.text("Salary Details", doc.internal.pageSize.getWidth() / 2, yPosition, {
    align: "center",
  });

  yPosition += 15;
  doc.text(`Generated Date: ${salaryData.generated_date}`, 25, yPosition);
  doc.text(`Work Hours: ${salaryData.work_hours} hrs`, doc.internal.pageSize.getWidth() / 2, yPosition);
  yPosition += 15;
  doc.text(`Hours Per Day: ${salaryData.hours_per_day}`, 25, yPosition);
  doc.text(`Salary Per Day: ${salaryData.salary_per_day}`, doc.internal.pageSize.getWidth() / 2, yPosition);
  yPosition += 15;
  doc.setFontSize(16);
  doc.text(`Total Salary: ${salaryData.total_salary}`, doc.internal.pageSize.getWidth() / 2, yPosition, {
    align: "center",
  });

  // Footer
  doc.line(10, doc.internal.pageSize.getHeight() - 30, doc.internal.pageSize.getWidth() - 10, doc.internal.pageSize.getHeight() - 30);
  doc.setFontSize(10);
  doc.text(
    `Generated on: ${new Date().toLocaleString()}`,
    doc.internal.pageSize.getWidth() / 2,
    doc.internal.pageSize.getHeight() - 20,
    { align: "center" }
  );

  doc.save(`SalarySlip_${salaryData.user_id}_${salaryData.generated_date}.pdf`);
};